import Vue from "vue";
import Router from "vue-router";
import Index from "./pages/index.vue";
import userAgreement from "./pages/user-agreement.vue";
import privacyPolicy from "./pages/privacy-policy.vue";
import disclaimer from "./pages/disclaimer.vue";
import terms from "./pages/terms.vue";
import legalInfo from "./pages/legal-info.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "home",
      component: Index,
    },
    {
      path: "/user-agreement",
      name: "user-agreement",
      component: userAgreement,
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: privacyPolicy,
    },
    {
      path: "/agreement",
      name: "agreement",
      component: userAgreement,
    },
    {
      path: "/disclaimer",
      name: "disclaimer",
      component: disclaimer,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacyPolicy,
    },
    {
      path: "/terms",
      name: "terms",
      component: terms,
    },
    {
      path: "/legal-info",
      name: "legal-info",
      component: legalInfo,
    },
  ],
});
